import http from '@/axios/http'
//获取n2n分组
export function GetListN2nServer(offset = 1, limit = 10) {
    const data = {
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/n2nServer/listN2nServer',
        method: 'post',
        data
    })
}
//筛选
export function queryKeyword(keyword, sort, offset, limit) {
    const data = {
        keyword: keyword,
        name: sort.serverName, //0：正序，1：倒序，服务名
        version: sort.serverVersion, //n2n版本
        port: sort.serverPort, //端口
        groupNum: sort.groupNum, //分组数
        deviceNum: sort.deviceNum, //设备数
        create: sort.serverCreate, //创建时间
        host: sort.serverAddress, //主机
        offset: offset,
        limit: limit
    }
    return http({
        url: '/api/n2nServer/queryKeyword',
        method: 'post',
        data
    })
}
//分组信息查询
export function queryKeywordGroupInfo(offset = 1, limit = 10, serverId, keyword, sort) {
    const data = {
        offset,
        limit,
        serverId,
        keyword,
        ...sort
    }
    return http({
        url: '/api/n2nServer/queryKeywordGroupInfo',
        method: 'post',
        data
    })
}
//添加n2n
export function addN2nServer(data) {
    return http({
        url: '/api/n2nServer/addN2nServer',
        method: 'post',
        data
    })
}
//修改n2n
export function updateN2nServer(data) {
    return http({
        url: '/api/n2nServer/updateN2nServer',
        method: 'post',
        data
    })
}
//删除n2n
export function delN2nServer(id) {
    const data = {
        serverId: id
    }
    return http({
        url: '/api/n2nServer/delN2nServer',
        method: 'post',
        data
    })
}
//迁移服务
export function updateGroupInfo(n2nInfoIds, serverId, port) {
    const data = {
        n2nInfoIds,
        serverId,
        port
    }
    return http({
        url: '/api/n2nServer/updateGroupInfo',
        method: 'post',
        data
    })
}
// 根据远程账号搜索
export function queryKeywordByRemoteAccount(gname = "", offset = 1, limit = 999) {
    const data = {
        gname,
        offset,
        limit
    }
    return http({
        url: '/api/n2nServer/queryN2nServer',
        method: 'post',
        data
    })
}

// 刷新远程服务地址
export function refreshRemoteServer() {
    return http({
        url: '/api/gather/updateIP',
        method: 'get'
    })
}